<template>

    <div class="filters">
        <div class="filters-mobile" @click="active = !active">
            filters
            <span class="expand">
                {{ this.defineSymbol }}
            </span>
        </div>

        <div class="filters-group" :class="[ active ? 'active' : '', float ? 'float' : '' ]" v-resize="handleResize" v-scroll="handleScroll">

            <div class="filter" v-for="(nested_filters, index) in filters">
                <product-filter v-for="(filters, name) in nested_filters.data"
                                :key="`filter-${name}`" :filters="filters"
                                :name="name"
                                @reloadProductsEvent="reloadProducts"
                                :filterPath="filterPath">
                </product-filter>
            </div>

            <div class="bool-filters">
                <div class="bool-filter" v-for="(name, filter) in boolFilters">
                    <label :for="filter">{{ name }}</label>
                    <input type="checkbox"
                           :name="filter"
                           :id="filter"
                           @change="applyBoolFilter($event, filter)"
                           :checked="checkBoolFilter(filter)">
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import ProductFilter from './ProductFilter'
    import Loader from './Loader'

    export default {
        name: 'filter-list',
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            filters: {
                type: Array
            },
            filterPath: {
                type: String,
                default: 'products'
            }
        },
        data: function() {
            return {
                float: false,
                active: true,
                boolFilters: {
                    sale: 'sales'
                }
            }
        },
        components: {
            ProductFilter,
            Loader
        },
        computed: {
            defineSymbol() {
                return this.active ? '-' : '+'
            },
            initialActive() {
                if (window.innerWidth > 992) {
                    this.active = true
                } else {
                    this.active = (this.$route &&
                        this.$route['query'] &&
                        this.$route['query']['search'] &&
                        this.$route['query']['search']) ? true : false
                }
            }
        },
        methods: {
            handleScroll() {
                this.float = window.scrollY > 144 && window.innerWidth > 992
            },
            handleResize() {
                if (window.innerWidth > 992) {
                    this.active = true
                    this.float = window.scrollY > 144
                } else {
                    this.active = (this.initialActive || this.active)
                    this.float = false
                }
            },
            applyBoolFilter(e, name) {
                let query = (this.$route['query'] && this.$route['query']['search']) ? Object.assign({}, this.$route['query']['search']) : {}
                query[name] = e.target.checked
                this.$router.push({query: {search: query} })
                this.reloadProducts()
            },
            reloadProducts() {
                this.$emit('reloadProductsEvent')
            },
            checkBoolFilter(type) {
                return this.$route.query && this.$route.query.search && this.$route.query.search[type] ? this.$route.query.search[type] != 'false' : false
            }
        },
        mounted() {
            this.initialActive
        }
    }

</script>

<style lang="scss" scoped>

    .filters-mobile{
        padding: 2px;
        font-weight: bold;
        font-size: 1.6rem;
        text-transform: uppercase;
        cursor: pointer;

        .expand{
            font-size: 1.6rem;
            float: right;
        }

        @media only screen and (min-width: 992px) {
            display: none;
        }
    }

    .filters-group{
        display: none;
        max-height: calc(100vh - 370px);
        overflow: auto;
        font-size: 1.4rem;

        &.float{
            width: 100%;
            max-width: 200px;
            position: fixed;
            top: 0;
        }

        &.active{
            display: block
        }

        .bool-filters{
            margin: 6px 0;

            .bool-filter{
                padding: 2px;
                font-weight: bold;
                text-transform: capitalize;

                label, input{
                    cursor: pointer;
                }
            }
        }
    }

</style>